module.exports = __webpack_public_path__ + "img/drh5_icon_whatsapp.6759156a.png";